module.exports = __webpack_public_path__ + "static/media/hotel-15.9c5abf44.jpg";